import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { AppService } from 'src/app/services/app.service';
import { BillService } from 'src/app/services/bill.service';
import { ServiceWorkerUpdateService } from 'src/app/services/service-worker-update.service';
import { UtilService } from 'src/app/services/util.service';
import { MessageService, MessageCheckOut, MessageOCR, MessageLoginOnClick, MessageShowUpgrade, MessageEmailSent, MessageSendEmail, MessageLoginExpired, MessageCordovaRestore, MessageRestoreLicense, MessagePdfExport } from 'src/app/services/message.service';
import { LazyLoadingService } from 'src/app/services/lazy-loading.service';
declare const $: any;
import { Subscription } from 'rxjs';
import { PWUserService, SWUserService, UserService } from 'src/app/services/user.service';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { UtilVoicesService } from 'src/app/services/util-voices.service';
import { VoiceCloningService } from 'src/app/services/voice-cloning.service';

@Component({
  selector: 'app-pw-alert-dialog',
  templateUrl: './pw-alert-dialog.component.html',
  styleUrls: ['./pw-alert-dialog.component.scss']
})
export class PwAlertDialogComponent implements OnInit, OnDestroy {
  appName = AppService.appName;
  canInstallApp = false;

  showChrome: boolean = true;
  showApple: boolean = true;
  showGoogle: boolean = true;
  showDesktop: boolean = true;
  isUpgrading: boolean = false;
  prorate = 'Calculating...';
  plan = { plan: '', price: '' };
  emailSend: boolean = false;
  isProrateAvailable = false;
  messageListenerRef: Subscription = null;

  voiceNameFormGroup = this._formBuilder.group({
    voiceNameControl: ['', [Validators.maxLength(50), Validators.required]]
  });
  descriptionFormGroup = this._formBuilder.group({
    descriptionControl: ['', [Validators.maxLength(200)]]
  });

  voice_tags = this.voiceUtilService.getVoiceTags();
  cloned_tags = [];

  shareEmailInput = '';
  shareEmails = [];
  share_Option = 'custom';
  hasSharingAgeConsent: boolean = false;
  emailFormControl = new FormControl('', [Validators.email]);

  constructor(
    private swUpdate: ServiceWorkerUpdateService,
    public utilService: UtilService,
    private voiceUtilService: UtilVoicesService,
    private userService: UserService,
    public dialog: MatDialog,
    private billService: BillService,
    protected messageService: MessageService,
    private lazyLoadingService: LazyLoadingService,
    public dialogRef: MatDialogRef<PwAlertDialogComponent>,
    private _formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,) {
    console.log("upgrade data", this.data);
    this.isProrateAvailable = this.data.liccode === '0' ? false : true;

    this.messageListenerRef = this.messageService.getMessage().subscribe(async (message) => {
      if (message.name === MessageEmailSent) {
        if (!this.emailSend) {
          this.emailSend = true;
        }
      }
    });

    if (data.type === 'editVoice') {
      if (data.voice) {
        if (data.voice.description) {
          this.descriptionFormGroup.controls['descriptionControl'].setValue(data.voice.description);
        }
        if (data.voice.tags && data.voice.tags.length > 0) {
          data.voice.tags.forEach(tag => {
            this.addTag(tag);
          });
        }
        if (data.voice.name) {
          this.voiceNameFormGroup.controls['voiceNameControl'].setValue(data.voice.name);
        }
      }
    }

    if (data.type === 'shareVoice') {
      console.log("shareVoice", data.voice);
      if (data.voice) {
        this.share_Option = data.voice.sharing
        if ('customSharedUsers' in data.voice && data.voice.sharing === 'custom' && data.voice.customSharedUsers.length > 0) {
          data.voice.customSharedUsers.forEach(email => {
            this.shareEmails.push(email);
          });
        }
      }
    }
  }

  ngOnInit(): void {
    if (AppService.isPW() && this.isProrateAvailable && !this.data.orderDisabled &&  ((this.data.type == 'order plus' && this.data.userRole == 'premium'))) {
      console.log('calculating prorate');
      this.calculateProrate();
      this.setPlan();
    }
    if (AppService.isPW() && this.data.type === 'upgrade plus') {
      console.log('calculating prorate');
      this.calculateProrateYearly();
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.messageListenerRef.unsubscribe();
  }

  /* add from  DialogInstallComponent */
  ngAfterViewChecked() {
    if (AppService.isPW()) {
      if (this.swUpdate.displayInstall === true) {
        this.canInstallApp = true;
      }
    }
  }

  setPlan() {
    if (this.data.isMonthly) {
      this.plan = { plan: 'Monthly', price: '$19.00 USD/Month' };
    } else {
      this.plan = { plan: 'Yearly', price: '$110.00 USD/Year' };
    }
  }

  calculateProrate() {
    let licCodeNew = '6005';
    if (this.data.liccode === '6006') {
      licCodeNew = '6008';
    }
    const alertConfig = new MatDialogConfig();
    this.billService.calculateProrate(this.data.email, this.data.liccode, licCodeNew)
      .then(resp => {
        console.log(resp.resp);
        this.prorate = '$' + (resp.resp / 100).toFixed(2);
      }).catch(err => {
        this.dialogRef.close();
        let text = 'Something went wrong, please try again.';
        if (err === 'ERR_SUB_NOT_FOUND') {
          text = 'Looks like you don\'t have an active Premium subscription. ' +
            'Please check to see if you have an active subscription or ' +
            'have previously upgraded to Plus.';
        }
        alertConfig.data = {
          type: 'alert',
          title: '',
          msg: text,
          data: null,
          button_left: null,
          button_center: 'OK',
          button_right: null
        };
        alertConfig.autoFocus = false;
        alertConfig.backdropClass = 'pw-dialog-backdrop';
        this.dialog.open(PwAlertDialogComponent, alertConfig);
      });
    return 0;
  }

  redirComm() {
    window.location.replace('../commercial');
  }

  calculateProrateYearly() {
    const alertConfig = new MatDialogConfig();
    this.billService.previewYearly(this.data.email)
      .then(resp => {
        console.log(resp);
        this.prorate = '$' + (resp.proration / 100).toFixed(2) + ' USD';
      }).catch(err => {
        this.dialogRef.close();
        let text = 'Something went wrong, please try again.';
        if (err === 'ERR_SUB_NOT_FOUND') {
          text = 'Looks like you don\'t have an active Plus Monthly subscription. ' +
            'Please check to see if you have an active subscription or ' +
            'have previously upgraded to Yearly.';
        }
        alertConfig.data = {
          type: 'alert',
          title: '',
          msg: text,
          data: null,
          button_left: null,
          button_center: 'OK',
          button_right: null
        };
        alertConfig.autoFocus = false;
        alertConfig.backdropClass = 'pw-dialog-backdrop';
        this.dialog.open(PwAlertDialogComponent, alertConfig);
      });
    return 0;
  }

  upgradeYearly() {
    const alertConfig = new MatDialogConfig();
    alertConfig.backdropClass = 'pw-dialog-backdrop';
    alertConfig.autoFocus = false;
    console.log(this.data.liccode);
    let licCodeNew = '6005';
    if (this.data.liccode === '6006') {
      licCodeNew = '6008';
    }
    this.isUpgrading = true;
    this.billService.upgradeToYearly(this.data.email)
      .then(resp => {
        this.isUpgrading = false;
        alertConfig.data = {
          type: 'alert',
          title: '',
          msg: 'You have successfully been upgraded to the Plus Yearly Plan!',
          hideCancel: true,
          buttonText: 'OK',
        };
        this.dialog.open(PwAlertDialogComponent, alertConfig).afterClosed().subscribe(() => {
          this.dialogRef.close();
        });
      }).catch(err => {
        this.isUpgrading = false;
        this.dialogRef.close();
        console.log('Something went wrong: ', err);
        let text = 'Something went wrong, please try again.';
        if (err === 'ERR_INVALID_SUB') {
          text = 'Looks like you don\'t have an active Plus Monthly subscription. ' +
            'Please check to see if you already have Plus Yearly or an active subscription';
        } else if (err === 'ERR_NO_VALID_SRC') {
          text = 'Looks like you don\'t have an active payment method attached to your account. ' +
            'Please update your card information and try again.';
        } else if (err === 'ERR_FAILED_UPDATE') {
          text = 'There was an issue while charging payment. If the error persists, please update ' +
            'your card information and try again.';
        }
        alertConfig.data = {
          type: 'alert',
          title: '',
          msg: text,
          data: null,
          button_left: null,
          button_center: 'OK',
          button_right: null
        };
        this.dialog.open(PwAlertDialogComponent, alertConfig);
      });
  }

  upgrade(): any {
    const alertConfig = new MatDialogConfig();
    alertConfig.backdropClass = 'pw-dialog-backdrop';
    alertConfig.autoFocus = false;
    console.log(this.data.liccode);
    let licCodeNew = '6005';
    if (this.data.liccode === '6006') {
      licCodeNew = '6008';
    }
    $('.processing').show();
    $('.upgrade-buttons').prop('disabled', true);
    this.billService.upgradeUserAccount(this.data.email, this.data.liccode, licCodeNew)
      .then(resp => {
        this.dialogRef.close();
        alertConfig.data = {
          type: 'alert',
          title: '',
          msg: 'You have successfully been upgraded to the Plus plan!',
          data: null,
          button_left: null,
          button_center: null,
          button_right: 'OK'
        };
        this.dialog.open(PwAlertDialogComponent, alertConfig);
      }).catch(err => {
        this.dialogRef.close();
        console.log('Something went wrong: ', err);
        let text = 'Something went wrong, please try again.';
        if (err === 'ERR_SUB_NOT_FOUND') {
          text = 'Looks like you don\'t have an active Premium subscription. ' +
            'Please check to see if you already have Plus or an active subscription';
        } else if (err === 'ERR_NO_VALID_SRC') {
          text = 'Looks like you don\'t have an active payment method attached to your account. ' +
            'Please update your card information and try again.';
        } else if (err === 'ERR_PAYMENT_FAILED') {
          text = 'There was an issue while charging payment. If the error persists, please update ' +
            'your card information and try again.';
        }
        alertConfig.data = {
          type: 'alert',
          title: '',
          msg: text,
          data: null,
          button_left: null,
          button_center: 'OK',
          button_right: null
        };
        this.dialog.open(PwAlertDialogComponent, alertConfig);
      });
  }

  openPayment(): void {
    this.openPaymentUpgrade();
  }

  openPaymentUpgrade(type: string = 'prem') {
    if (AppService.isPW() || AppService.isAndroid() || AppService.isIOS()) {
      (this.userService as PWUserService).upgrade(type);
    } else if (AppService.isSoftware()) {
      (this.userService as SWUserService).upgrade(type);
    }
    this.dialog.closeAll();
  }

  installApp(): void {
    if (AppService.isPW() || AppService.isAndroid() || AppService.isIOS()) {
      this.swUpdate.promptEvent.prompt();
      this.swUpdate.displayInstall = false;
    }
    this.utilService.gtag('event', { eventName: 'click', eventCategory: 'AppInstall', eventLabel: 'AppInstall from PWA' });

    this.dialogRef.close(true);
  }

  viewIOSApp() {
    this.utilService.viewOnIOSAppStore();
  }

  viewAndroidApp() {
    this.utilService.viewOnGooglePlayStore();
  }

  DownloadSoftware() {
    this.utilService.DownloadSoftware();
  }

  viewChromeExtension() {
    this.utilService.viewChromeExtensionOnChromeWebStore();
  }

  loadIcon(type: string) {
    switch (type) {
      case 'chrome':
        this.showChrome = false;
        break;
      case 'apple':
        this.showApple = false;
        break;
      case 'google':
        this.showGoogle = false;
        break;
      case 'desktop':
        this.showDesktop = false;
        break;
      default:
        break;
    }
  }

  orderNow(type: string) {
    this.messageService.sendMessage({ name: MessageCheckOut, data: '' });
  }

  showUpgrade(type: string) {
    this.messageService.sendMessage({ name: MessageShowUpgrade, data: type });
    this.dialogRef.close();
  }

  checkOut(type: string) {
    this.messageService.sendMessage({ name: MessageCheckOut, data: type });
  }

  manualOCR() {
    this.messageService.sendMessage({ name: MessageOCR, data: { status: 'manualOCR' } });
    this.dialogRef.close();
  }

  loginBtnonClick() {
    this.messageService.sendMessage({ name: MessageLoginOnClick, data: 'continue dialog' });
  }

  sendEmail(type: string) {
    this.messageService.sendMessage({ name: MessageSendEmail, data: type });
  }

  restoreLicenseClick() {
    this.lazyLoadingService.loadAppInitialModule()
      .then(_ => {
        if (AppService.isIOS() || AppService.isAndroid()) {
          this.messageService.sendMessage({ name: MessageCordovaRestore });
        } else {
          this.messageService.sendMessage({ name: MessageRestoreLicense });
        }
      });
  }

  loginExpiredClick() {
    this.lazyLoadingService.loadAppInitialModule()
      .then(_ => {
        this.messageService.sendMessage({ name: MessageLoginExpired });
      });
  }

  addTag(tag) {
    if (this.cloned_tags.indexOf(tag) == -1) {
      this.cloned_tags.push(tag);
    } else {
      this.cloned_tags.splice(this.cloned_tags.indexOf(tag), 1);
    }
  }

  selectedTag(tag) {
    const isSelected = (this.cloned_tags.indexOf(tag) != -1);
    return isSelected;
  }

  updateVoice() {
    // return Promise.resolve()
    // .then(()=>{
    //   if(this.data.voice.name !== this.voiceNameFormGroup.controls.voiceNameControl.value){
    //   // check for bad words
    //   }else{
    //     return Promise.resolve(false);
    //   }
    // })
    // .then((hasBadWords)=>{
    //   if(hasBadWords){
    //     return Promise.resolve(false);
    //   }else{
    //     const voice = {
    //       name: this.voiceNameFormGroup.controls.voiceNameControl.value,
    //       description: this.descriptionFormGroup.controls.descriptionControl.value,
    //       tags: this.cloned_tags
    //     }
    //     this.dialogRef.close(voice);
    //   }
    // })
    // .catch((err)=>{
    // });
    const voice = {
      name: this.voiceNameFormGroup.controls.voiceNameControl.value,
      description: this.descriptionFormGroup.controls.descriptionControl.value,
      tags: this.cloned_tags
    }
    this.dialogRef.close(voice);
  }

  updateVoiceSharing() {
    const res = {
      sharing: this.share_Option
    }
    if (this.share_Option === 'custom') {
      let emails = this.getEmailsToAddAndRemove(this.data.voice.customSharedUsers, this.shareEmails);
      res['emailsToAdd'] = emails.add;
      res['emailsToRemove'] = emails.remove;
    }
    this.dialogRef.close(res);
  }

  getEmailsToAddAndRemove(oldEmails = [], newEmails = []) {
    const add = newEmails.filter(email => oldEmails.indexOf(email) === -1);
    const remove = oldEmails.filter(email => newEmails.indexOf(email) === -1);
    return { add, remove };
  }

  addEmail(email) {
    // duplicate check
    let emailSet = new Set(this.shareEmails.map(email => email.toLowerCase()));
    if (emailSet.has(email.toLowerCase())) {
      return;
    }
    this.shareEmails.push(email);
  }

  remove(email): void {
    const index = this.shareEmails.indexOf(email);
    if (index >= 0) {
      this.shareEmails.splice(index, 1);
    }
  }
  exportPdf(withAnnotations: boolean) {
    this.messageService.sendMessage({ name: MessagePdfExport, data: withAnnotations });
  }
}
